require('@engine/lib/plugins/jquery.daterange_picker');

export function applyDaterangePicker() {
  var datepickerElement = $('[id$=_daterange_picker]');

  if (datepickerElement.length) {
    var object_name = datepickerElement.attr('id').replace('_daterange_picker', '');
    datepickerElement.daterange_picker({
      altFields: {
        from: object_name + '_date_from',
        to: object_name + '_date_to',
        created_at: object_name + '_created_at'
      }
    });
  }
}